module.exports = __webpack_public_path__ + "img/3.5fe2bc8e.jpg";